// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmnotifpg-inline-1 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.pmnotifpg-inline-2 {
  margin-bottom: 12px;
}

.pmnotifpg-inline-3 {
  padding: 0;
}

.pmnotifpg-inline-4 {
  font-size: 13px;
  font-weight: 600;
}

.pmnotifpg-inline-5 {
  font-size: 14px;
  font-weight: 700;
}

.pmnotifpg-inline-6 {
  margin-top: 8px;
  color: #475569;
}

.pmnotifpg-inline-7 {
  margin-top: 10px;
  font-size: 11px;
  color: #94a3b8;
}

.pmnotifpg-inline-8 {
  margin-top: 12px;
}

.pmnotifpg-dyn-1 {
  padding: 20px;
  text-align: center;
  color: var(--pmnotifpg-1-color);
}

.pmnotifpg-dyn-2 {
  padding: 20px;
  text-align: center;
  color: var(--pmnotifpg-2-color);
}

.pmnotifpg-dyn-3 {
  padding: 11px 14px;
  border-bottom: var(--pmnotifpg-3-border-bottom);
  cursor: pointer;
  background: var(--pmnotifpg-3-background);
}

.pmnotifpg-dyn-4 {
  font-size: 11px;
  color: var(--pmnotifpg-4-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMNotifPg.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".pmnotifpg-inline-1 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n}\n\n.pmnotifpg-inline-2 {\n  margin-bottom: 12px;\n}\n\n.pmnotifpg-inline-3 {\n  padding: 0;\n}\n\n.pmnotifpg-inline-4 {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pmnotifpg-inline-5 {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.pmnotifpg-inline-6 {\n  margin-top: 8px;\n  color: #475569;\n}\n\n.pmnotifpg-inline-7 {\n  margin-top: 10px;\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.pmnotifpg-inline-8 {\n  margin-top: 12px;\n}\n\n.pmnotifpg-dyn-1 {\n  padding: 20px;\n  text-align: center;\n  color: var(--pmnotifpg-1-color);\n}\n\n.pmnotifpg-dyn-2 {\n  padding: 20px;\n  text-align: center;\n  color: var(--pmnotifpg-2-color);\n}\n\n.pmnotifpg-dyn-3 {\n  padding: 11px 14px;\n  border-bottom: var(--pmnotifpg-3-border-bottom);\n  cursor: pointer;\n  background: var(--pmnotifpg-3-background);\n}\n\n.pmnotifpg-dyn-4 {\n  font-size: 11px;\n  color: var(--pmnotifpg-4-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
